// extracted by mini-css-extract-plugin
module.exports = {"searchModalBtn":"ModalForm_searchModalBtn__idC4x"};